import React from 'react';
import Image from 'next/image';
import useWindowSize from 'hooks/useWindowSize';
import './styles.scss';

interface GavelCircleProps {
    text: string;
    color: string;
    image: string;
}

const GavelCircle: React.FC<GavelCircleProps> = ({ text, color, image }) => {
    const windowSize = useWindowSize();
    const width = windowSize.width;

    return (
        <div className="gavel-circle" style={{ backgroundColor: color }}>
            <div>
                <Image width={width > 1200 ? 120 : 80} height={width > 1200 ? 120 : 80} src={image} alt={text} />
                <p>{text}</p>
            </div>
        </div>
    );
};

export default GavelCircle;
